import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Asegúrate de que axios tenga el encabezado adecuado
axios.defaults.headers.post['Content-Type'] = 'application/json';

export const ultimoDulce = createAsyncThunk(
    'ultimoDulce/getUltimaAguaDulce',
    async ({ lat, lon }) => {
        try {
            // Hacemos una solicitud GET al backend con latitud y longitud como parámetros
            const response = await axios.get('/api/sensor/getUltimaAguaDulce', {
                params: { lat, lon } // Usamos 'params' para enviar los parámetros en la URL
            });

            // Retornamos la respuesta de la API
            return response.data;
        } catch (error) {
            // Si ocurre un error, lo lanzamos para que sea manejado en el reducer
            throw error;
        }
    }
);